import { CreditBalance, Transaction, TrialStatus } from "../model/creditHistoryModel";
import {
  CreditHistoryAction,
  GetCreditBalaceAction,
} from "./creditHistory.action";

export type CreditHistoryState = {
  creditHistory: Transaction[];
  loading: boolean;
  error: string | null;
  total: number;
  hasMore: boolean;
  startDate: string;
  endDate: string;
  currentPage: number;
  pageSize: number;
  isSearched: boolean;
  searchVersion: number;
  trialStatus?: TrialStatus;
};

//Credit History Initial State
export const creditHistoryInitialState: CreditHistoryState = {
  creditHistory: [],
  loading: false,
  error: null,
  total: 0,
  hasMore: false,
  startDate: "",
  endDate: "",
  currentPage: 1,
  pageSize: 5,
  isSearched: false,
  searchVersion: 0,
};

//Total Balance Initial State
export const totalBalanceState: CreditBalance = {
  company_id: "",
  balance: 0,
  total_purchased: 0,
  total_topup: 0,
  total_bonus: 0,
  total_used: 0,
  total_adjusted: 0,
  subscription_credits_per_period: null,
  topup_discount_percent: null,
  updated_at: "",

};

export function creditHistoryReducer(
  state: CreditHistoryState,
  action: CreditHistoryAction,
): CreditHistoryState {
  switch (action.type) {
    case "SET_CREDIT_HISTORY":
      return {
        ...state,
        creditHistory: action.payload,
      };
    case "SET_LOADING":
      return {
        ...state,
        loading: action.payload,
      };
    case "SET_ERROR":
      return {
        ...state,
        error: action.payload,
      };
    case "SET_TOTAL":
      return {
        ...state,
        total: action.payload,
      };
    case "SET_SEARCHED":
      return {
        ...state,
        isSearched: true,
        searchVersion: state.searchVersion + 1,
      };

    case "RESET_FILTER":
      return {
        ...state,
        startDate: "",
        endDate: "",
        isSearched: false,
        currentPage: 1,
        searchVersion: state.searchVersion + 1,
      };

    case "SET_PAGE":
      return {
        ...state,
        currentPage: action.payload,
      };
    case "SET_PAGE_SIZE":
      return {
        ...state,
        pageSize: action.payload,
        currentPage: 1,
      };
    case "NEXT_PAGE":
      return { ...state, currentPage: state.currentPage + 1 };

    case "PREV_PAGE":
      return { ...state, currentPage: state.currentPage - 1 };
    case "SET_TRIAL_STATUS":
      return {
        ...state,
        trialStatus: action.payload,
      };
    case "SET_HAS_MORE":
      return {
        ...state,
        hasMore: action.payload,
      };
    case "SET_START_DATE":
      return {
        ...state,
        startDate: action.payload,
      };
    case "SET_END_DATE":
      return {
        ...state,
        endDate: action.payload,
      };
  }
  return state;
}

export const getBalanceReducer = (
  state: CreditBalance,
  action: GetCreditBalaceAction,
): CreditBalance => {
  switch (action.type) {
    case "SET_BALANCE":
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
